import { useEffect } from 'react';
export const useInfiniteScroll = ({ nodeId, threshold = 0.25, fetchNextPage, hasNextPage, inverted }) => {
    useEffect(() => {
        var _a;
        let fetching = false;
        const onScroll = (e) => {
            const target = e.target;
            const { scrollHeight, scrollTop, clientHeight } = target;
            const bottom = scrollHeight - scrollTop - clientHeight;
            const top = scrollTop;
            const shouldFetch = inverted
                ? top < scrollHeight * threshold
                : bottom < scrollHeight * threshold;
            if (shouldFetch && !fetching && hasNextPage) {
                fetching = true;
                fetchNextPage()
                    .then(() => {
                    fetching = false;
                })
                    .catch((err) => {
                    console.log(err);
                });
            }
        };
        (_a = document.getElementById(nodeId)) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
        return () => {
            var _a;
            (_a = document.getElementById(nodeId)) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll);
        };
    }, [nodeId, fetchNextPage, hasNextPage, threshold, inverted]);
};
//# sourceMappingURL=useInfiniteScroll.js.map